import { render, staticRenderFns } from "./WrapperLayout.vue?vue&type=template&id=63520f26&"
import script from "./WrapperLayout.vue?vue&type=script&lang=js&"
export * from "./WrapperLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports